export default (state: IKeyValue) => ({
	latitude: state.latitude,
	longitude: state.longitude,
	timestamp: state.timestamp,
});
